import { DevelopDefinitions } from "../widgets/developDefinitions/developDefinitions.js";

let fdDevelopDefinitions = document.getElementById('fdDevelopDefinitions');
let opts = {};
let fdDevelopDefinitionsWidget = new DevelopDefinitions(fdDevelopDefinitions, opts);